<template>
  <view class="mob_conview">
    <view class="bgview">
      <img src="../assets/images/mob_phone.png" />
    </view>
    <view class="contentV">
      <view class="bottom_v">
        <img src="../assets/images/mob_down_botton.png" />
        <view @click="downAppClick" class="btn_view">
          <text>立即下载</text>
        </view>
      </view>
    </view>
  </view>

</template>

<script setup>
function downAppClick () { 
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
    iosDownEvent()
  } else { 
    androidDownEvent()
  }
}

function androidDownEvent () { 
const link = document.createElement('a');
    link.href = 'https://oss.congbaoba.cn/apk/cbmy.apk';
    link.download = 'mianyabo.apk';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

function iosDownEvent() {
    const link = document.createElement('a');
    link.href = 'https://apps.apple.com/app/id6749663651';
    link.download = 'mianyabo.download';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

</script>

<style lang="scss">

.mob_conview{
  display: flex;
  background: #E6EBF5;
  height: 100vh;
  width: 100vw;
  position: relative;
  .bgview{
    display: flex;
    position: absolute;
    width: 100%;
    justify-content: center;
    img{
      margin-top: 30px;
      width: 250px;
      height: 504px;
      z-index: 1;
    }
  }

  .contentV{
    display: flex;
    position: absolute;
    width: 100%;
    height: 350px;
    left: 0;
    bottom: 0;
    z-index: 2;
    .bottom_v{
      display: flex;
      width: 100%;
      height: 100%;
      position: absolute;
      justify-content: center;
      img{
        width: 100%;
        height: 350px;
      }
      .btn_view{
        display: flex;
        position: absolute;
        height: 51px;
        background: #1A79FF;
        border-radius: 50px;
        box-shadow: 0px 10px 10px 1px rgba(0,0,0,0.16);
        bottom: 90px;
        width: 80%;
        justify-content: center;
        align-self: center;
        text{
          line-height: 51px;
          font-weight: 500;
          font-size: 16px;
          color: #FFFFFF;
        }
      }
    }
  }

}

</style>